import { useGetCurrentEmployeesQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import CurrentEmployees from "./CurrentEmployees";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getAppType } from "utils/helper";

const CurrentEmployeesModel = (): JSX.Element => {
  const appType = getAppType();
  const { data, error, loading, refetch } = useGetCurrentEmployeesQuery({
    variables: { uuid: getProspectUuid(), appType },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorPage />;
  }
  return <CurrentEmployees data={data?.prospect} refetchData={refetch} />;
};

export default CurrentEmployeesModel;
